import { ActionTree } from 'vuex';
import { UiState, RootState } from '../types';

export const actions: ActionTree<UiState, RootState> = {
	/**
	 * Toggle the mobile navigation state
	 *
	 * @param {boolean} isOpen
	 * @return {void}
	 */
	toggleMobileNav({ commit }, isOpen: boolean): void {
		commit('TOGGLE_MOBILE_NAV', isOpen);
	},

	/**
	 * Set the desktop navigation expanded state
	 *
	 * @param {boolean} isExpanded
	 * @return {void}
	 */
	setDesktopNavExpanded({ commit }, isExpanded: boolean): void {
		commit('SET_DESKTOP_NAV_EXPANDED', isExpanded);
	}
};